<template>
    <div>
        <member-write-link v-for="writeLayout in writeLayouts" :key="`memberComp${writeLayout}`" :writeLayout="writeLayout" :memberData="memberData" :profileFiles="profileFiles"></member-write-link>
    </div>
</template>

<script>
import MemberWriteLink from "@/components/member/MemberWriteLink";
import memberUtil from "@/components/member/memberUtil";
import util from "@/mixins/util";
import alertMixins from "@/mixins/alertMixins";
import elFileMixins from "@/mixins/elFileMixins";
import EventBus from "@/utils/event-bus";
import memberValidator from "@/mixins/validators/memberValidator";
import DeleteClass from "@/mixins/deleteClass";

export default {
    name: "MemberWriteComponent",
    mixins: [memberUtil, alertMixins, elFileMixins, memberValidator],
    components: {MemberWriteLink},
    provide() {
        return {
            memberWriteSetData: this.setData,
            memberResetPenalty:this.runResetPenaltyConfirm
        }
    },
    inject: ['changeLoading'],
    props: {
        memberType: {default: ''},
        memberKey: {default: 0},
    },
    data() {
        return {
            writeLayouts: [],
            getFunc: '',
            detailApiParamsSet: {},
            getDetailParamsKey: 'id',
            writeFunc: '',
            writeApiParamSet: {},
            parsingData: {},
            directUrl: '',
            directType: '',
            keyName: '',
            writeSuccessType: 1,
            writeFailTypes: {},
            fileType: '',


            deleteFunc: '',
            deleteApiParamsSet: {
            },
            deleteSuccessType: 1,
            deleteFailTypes: {},
            deleteAlertText: '',
            deleteSuccessAlertText: '',
            DeleteClass: null,

            memberData: {},
            profileFiles:[],
        }
    },
    created() {
        this.initFilterConfig();
        if(this.memberKey === 0) {
            this.initTemplateConfig();
        }else{
            this.getMember();
        }
    },
    mounted() {
        EventBus.$on('writeMember', this.writeMember)
        EventBus.$on('runMemberQuit', this.memberQuitAlert)
        EventBus.$on('runMemberWriteDelete', this.runDeleteConfirm)
        //

    },
    beforeDestroy() {
        EventBus.$off('writeMember')
        EventBus.$off('runMemberQuit')
        EventBus.$off('runMemberWriteDelete')

    },
    destroyed() {},
    computed: {
    },
    methods: {
        setData(type, value) {
            this[type] = value;
        },
        initTemplateConfig() {
            let config = this.returnMemberConfig(this.memberType);
            this.writeLayouts = config.writeLayouts;
        },
        initFilterConfig() {
            let config = this.returnMemberConfig(this.memberType);
            this.getFunc = config.getFunc;
            this.detailApiParamsSet = config.detailApiParamsSet;
            this.getDetailParamsKey = config.getDetailParamsKey ? config.getDetailParamsKey :  this.getDetailParamsKey;
            this.writeFunc = config.writeFunc;
            this.writeApiParamSet = config.writeApiParamSet;
            this.parsingData = config.parsingData;
            this.directUrl = config.directUrl;
            this.directType = config.directType;
            this.fileType = config.fileType;
            this.keyName = config.keyName;
            this.writeSuccessType = config.writeSuccessType;
            this.writeFailTypes = config.writeFailTypes;



            this.deleteFunc = config.deleteFunc;
            this.deleteApiParamsSet = config.deleteApiParamsSet;
            this.deleteSuccessType = config.deleteSuccessType;
            this.deleteFailTypes = config.deleteFailTypes;
            this.deleteAlertText = config.deleteAlertText
            this.deleteSuccessAlertText = config.deleteSuccessAlertText;

            this.newDeleteClass();
        },
        newDeleteClass() {
            if(!util.isEmpty(this.deleteFunc)) {
                let deleteOptions = {
                    func: this.$api.$member[this.deleteFunc],
                    apiParamSet: this.deleteApiParamsSet,
                    keyName: this.keyName,
                    successType: this.deleteSuccessType,
                    errorTypes: this.deleteFailTypes,
                    afterFunc: this.deleteAfterFunc,
                }
                this.DeleteClass = new DeleteClass(deleteOptions);
            }
        },
        getMember() {
            // EventBus.$emit("apiLoading",true)
            let params = JSON.parse(JSON.stringify(this.detailApiParamsSet));
            params[this.getDetailParamsKey] = this.memberKey;
            this.$api.$member[this.getFunc](params).then(res => res.Data.Result).then( async res => {
                if(res.Info.type != 1 || res.List.length === 0) {
                    this.createAlert({
                        title: '',
                        content: '데이터를 불러올 수 없습니다.',
                        btnText: '확인',
                        hide: () => {
                            this.$router.back();
                        }
                    });
                    return;
                }
                params = {
                    a_container_id: this.memberKey,
                    a_container_type: this.fileType,
                }
                await this.$api.$file.getFile(params).then(res => res.Data.Result).then(res => {
                    if (!util.isEmpty(res.List) && res.Info.type == 1) {
                        this.profileFiles = res.List;
                    }
                })
                this.memberData = res.List[0];
                // EventBus.$emit("apiLoading",false)
                this.initTemplateConfig();
            })
        },
        writeMember() {
            let dataKeys = Object.keys(this.parsingData);
            if(!util.isEmpty(this.fileType)) {
                dataKeys.push('files')
            }
            this.$validate(dataKeys).then((success) => {
                if(!success) {
                    this.errorAlert('필수데이터를 확인해주세요.');
                    util.Array.each(this.writeLayouts, (writeLayout, index, arr) => {
                        EventBus.$emit(`${writeLayout}Validator`);
                    })
                    return false;
                }
                // let params = this.createApiParamSet;
                this.changeLoading(true);
                let params = JSON.parse(JSON.stringify(this.writeApiParamSet))
                dataKeys = Object.keys(this.parsingData);
                dataKeys.forEach(dataKey => {
                    params[this.parsingData[dataKey]] = this[dataKey];
                })
                if(this.memberKey != 0) {
                    params[this.keyName] = this.memberKey;
                }
                try {
                    this.$api.$member[this.writeFunc](params).then(res => res.Data.Result).then(res => {
                        let type = this.returnMemberWriteType(res.Info.type);
                        if(this.memberType === 'createPremium' || this.memberType === 'updatePremium') {
                            type = this.returnMemberWritePremiumType(res.Info.type);
                        }
                        if(type != true) {
                            this.errorAlert(type);
                            this.changeLoading(false);
                            return false;
                        }
                        if(!util.isEmpty(this.deleteFiles)) {
                            this.removeFiles(this.deleteFiles)
                        }

                        if(!util.isEmpty(this.fileType) && !util.isEmpty(this.files)){
                            for(let i = 0; i< this.files.length; i++){
                                this.files[i].a_seq = i;
                            }
                            let uploadFileList = this.files.filter(item=> !item.a_idx);
                            this.uploadFiles(uploadFileList, this.fileType, res.List).then(success => {
                                // this.afterFunc(res.List);
                            });
                            
                            let deleteFiles = this.profileFiles.reduce((newArray , file) => {
                                let isDelete = this.files.findIndex(item => file.a_idx == item.a_idx);
                                if(isDelete == -1){
                                    newArray.push(file);
                                }
                                return newArray;
                            },[]);
                            if(this.memberKey != 0 && deleteFiles.length > 0){
                                deleteFiles.forEach(file => {
                                    if(file.a_idx){
                                        this.$api.$member.deleteProfile({mb_no:this.memberKey,a_idx:file.a_idx}).then(res => res.Data.Result).then(ress => {
                                    });
                                    }
                                });
                            }   
                            this.afterFunc(res.List);
                        }else{
                            this.afterFunc(res.List);
                            // this.afterFunc(res.List);
                        }
                    })
                }catch (e) {
                    this.changeLoading(false);
                    console.log(e)
                }
            })
        },
        returnMemberWritePremiumType(type) {
            if(type == this.writeSuccessType) {
                return true;
            }else{
                return util.isEmpty(this.writeFailTypes[type]) ? '저장에 실패하였습니다.' : this.writeFailTypes[type]
            }
        },
        afterFunc(key) {
            this.changeLoading(false);
            if(this.memberKey != 0) {
                EventBus.$emit('memberListUpdateAfterFunc', this.keyName, Number(this.memberKey));
            }else{
                EventBus.$emit('memberListAddAfterFunc');
            }
            let detailKey = key;
            this.createAlert({
                title: '',
                content: '저장되었습니다.',
                btnText: '확인',
                hide: () => {
                    if(this.directType === 'back') {
                        this.$router.back();
                        return false;
                    }
                    if(this.directUrl === '') {
                        this.writeLayouts = [];
                        this.deleteFiles = [];
                        this.getMember();
                        return false;
                    }
                    let url = this.directUrl;
                    if(this.directType === 'detail') {
                        url = url+detailKey;
                    }
                    this.$router.push(url);
                }
            })
        },
        memberQuitAlert() {
            this.openInputConfirm({
                title: '강제탈퇴',
                confirmText: '강제탈퇴',
                cancelText: '닫기',
                placeholder: '강제탈퇴사유입력',
                validator: (value) => {
                    if (!value) {
                        return '강제탈퇴사유를 입력해주세요.'
                    }
                },
                attributes: {maxlength: 200,},
                confirm: this.memberQuit,
            })
        },
        memberQuit(reason) {
            let params = {
                moc_idx : [1],
                mo_reason : [reason],
                mb_type: 'normal',
                mb_no: this.memberKey,
            }
            try {
                this.$api.$member.deleteMember(params).then(res => res.Data.Result).then(res => {
                    let type = this.returnMemberWriteType(res.Info.type);
                    if(type === true) {
                        this.createAlert({
                            content: '강제탈퇴처리되었습니다.',
                            hide: () => {
                                this.$router.back();
                            }
                        })
                    }else{
                        this.errorAlert(type);
                    }
                })
            }catch (e) {
                console.log(e);
            }
        },
        returnMemberWriteType(type) {
            switch (type) {
                case 1:
                    return true;
                case -2:
                    return "탈퇴하는 멤버가 회원이 아닙니다.";
                case -3:
                    return "회원에 대한 정보가 없습니다.";
                case -4:
                    return "현재 비밀번호가 맞지 않습니다.";
                case -5:
                    return "카테고리가 맞지않습니다.";
                case -6:
                    return "탈퇴사유가 없습니다.";
                case -7:
                    return "일반회원이 다른회원을 탈퇴시킬수 없습니다.";
                default:
                    return "회원 강제탈퇴에 실패하였습니다.";
            }
        },
        runResetPenaltyConfirm(){
            this.createConfirm({
                content: '패널티를 초기화 하시겠습니까?',
                confirm: () => {
                    this.resetPenalty()
                }
            })
        },
        resetPenalty() {
            let params ={
                mb_no : this.memberKey
            }
            try {
                this.$api.$declaration.resetDeclaration(params).then(res => res.Data.Result).then(res => {
                    let type = this.returnResetPenaltyType(res.Info.type);
                    if(type === true) {
                        this.createAlert({
                            content: '패널티가 초기화 되었습니다.',
                            hide: () => {
                                this.getMember()
                            }
                        })
                    }else{
                        this.errorAlert(type);
                    }
                })
            }catch (e) {
                console.log(e);
            }
        },
        returnResetPenaltyType(type){
            switch (type) {
                case 1:
                    return true;
                case -100:
                    return "필수값이 없습니다.";
                case -403:
                    return "권한이 없습니다.";
                case -404:
                    return "회원이 없습니다.";
                default:
                    return "패널티 초기화에 실패하였습니다.";
            }
        },
        runDeleteConfirm() {
            if(util.isEmpty(this.deleteAlertText)) {
                this.runDelete();
            }else{
                this.createConfirm({
                    content: this.deleteAlertText,
                    confirm: () => {
                        this.runDelete();
                    }
                })
            }
        },
        runDelete() {
            this.changeLoading(true);
            this.DeleteClass.runDelete(this.memberKey);
        },
        deleteAfterFunc() {
            this.createAlert({
                content: this.deleteSuccessAlertText,
                hide: () => {
                    this.changeLoading(false);
                    this.$router.back();
                },
            })
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
